import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { AddIndividualFinanceAccountsForm } from './add-individual-finance-accounts-form'
import { AddInstitutionalFinanceAccountsForm } from './add-institutional-finance-accounts-form'
import { useModuleStatus } from '../../../../hooks/useModuleStatus'
import RectangularTabs from '../../../widgets/components/RectangularTabs'

export const AddFinanceAndAccountsForm = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const { moduleStatus } = useModuleStatus()
  const [searchParams] = useSearchParams()
  const  financeAccountId= searchParams.get('financeAccountsId')
  const tab = searchParams.get('tab')


  const options = [
    {
      id: 1,
      slug: 'individual',
      title: formatMessage({id: 'Individual'}),
      subTitle: formatMessage({id: 'An Individual Person'}),
    },
    {
      id: 2,
      slug: 'institution',
      title: formatMessage({id: 'Institutional'}),
      subTitle: formatMessage({id: 'A Legal Entity'}),
    },
  ]
  // Filter options based on moduleStatus
  const filteredOptions = moduleStatus['stakeholder'] !== false
    ? options
    : options.filter((option) => ![2].includes(option.id));

  // State for managing the selected tab
  const [selectedTab, setSelectedTab] = useState<number>(filteredOptions[0]?.id || 1);

  // Handle tab change
  const handleTabChange = (id: number) => {
    setSelectedTab(id);
    const selectedOption = options.find(option => option.id === id);
    if (selectedOption) {
      navigate(`${location.pathname}?tab=${selectedOption.slug.toLowerCase()}`);
    }
  };

  useEffect(() => {
    if (!financeAccountId) {
      const handleTabChange = () => {
        navigate(`${location.pathname}?tab=${options[0].slug}`)
      }
      handleTabChange() // eslint-disable-next-line
    } else {
      const selectedOption = options.find((option) => option.slug === tab)
      if (selectedOption) {
        setSelectedTab(selectedOption.id)
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps



  return (<>
    <p className=''>{formatMessage({ id: 'Please select the type' })}</p>

    <RectangularTabs
      options={filteredOptions}
      selectedTab={selectedTab}
      handleTabChange={handleTabChange}
      isDisabled={!!financeAccountId}
    />
    <div className='my-md-8 my-auto w-100'>
      {selectedTab === 1 && <AddIndividualFinanceAccountsForm />}

      {selectedTab === 2 && <AddInstitutionalFinanceAccountsForm />}
    </div>
  </>
  )
}
